/** 영어. 다국어표 키는 표 그대로, 나머지는 기존 카피 유지. */
export const COPY_EN = {
    "common.back": "Back",
    "common.brandCaption": "Korea's beauty, one shot of you",
    "common.home": "Home",
    "common.keepGoing": "Keep going",
    "common.homeConfirmTitle": "Start over?",
    "common.homeConfirmBody": "Everything so far will be lost.",
    "idle.title": "Are you still there?",
    "idle.body": "Returning to the start in {sec}s unless you tap",
    "common.brandTag": "Korean culture photo booth",
    "journey.theme": "Theme",
    "journey.style": "Style",
    "journey.capture": "Capture",
    "journey.result": "Result",
    "journey.receive": "Receive",
    "attract.tagline": "Korean Culture AI Photobooth",
    "attract.headline": "Step into the\nbeauty of Korea",
    "attract.cta": "Start",
    "themeSelect.title": "Choose your theme",
    "themeSelect.count": "{n} themes",
    "themeSelect.cta": "Select",
    "themeSelect.storiesLabel": "Stories",
    "styleSelect.back": "Choose another theme",
    "styleSelect.title": "Pick your style",
    "styleSelect.cta": "Go with this style",
    "styleSelect.next": "Next style",
    // consent
    "consent.title": "Before taking your photo,\nyour consent is required",
    "consent.required": "Required",
    "consent.view": "View",
    "consent.close": "Close",
    "consent.allAgree": "Agree to all",
    "consent.processor": "Data controller: {name}",
    "consent.contact": "Contact: {contact}",
    "consent.refusal": "You cannot use the photo service without consenting",
    "consent.cta": "Agree",
    "consent.decline": "Decline",
    "consent.back": "Back to style selection",
    "preview.back": "Choose another style",
    "preview.title": "Look at the camera",
    "preview.tip1": "Face the camera so we can see you clearly.",
    "preview.tip2": "The photo is taken {sec} seconds after you tap.",
    "preview.tip3": "Don't like the result? You can retake.",
    "preview.placeholderTitle": "Step in front of the camera",
    "preview.placeholderBody": "Connecting the camera.\nPlease allow camera access if asked.",
    "preview.connecting": "Connecting camera…",
    "preview.shoot": "Take photo",
    "preview.openCamera": "Open camera",
    "preview.closeCamera": "Back to tips",
    "preview.cancel": "Cancel",
    "preview.retry": "Reconnect camera",
    "preview.note": "Your photo is used only for the AI transformation.",
    "preview.holdStill": "Hold still",
    "preview.confirmTitle": "Use this photo?",
    "preview.confirmHint": "Eyes closed or blurry? Take it again.",
    "preview.confirmRetake": "Retake",
    "preview.confirmProceed": "Continue",
    "preview.errorTitle": "Camera unavailable",
    "preview.errorTitleNoDevice": "No camera found",
    "preview.errorPermissionDenied": "Camera access is off. Allow the camera in browser settings and reconnect.",
    "preview.errorNoDevice": "This device has no connected camera. Connect one and try again.",
    "preview.errorInsecureContext": "The camera works on HTTPS only.",
    "preview.errorTimeout": "The camera isn't responding. Make sure no other app is using it, then reconnect.",
    "preview.errorUnknown": "Couldn't connect the camera. Please try again.",
    "generate.title": "Crafting your photo",
    "generate.hint": "About 30 seconds",
    "generate.selectedLabel": "SELECTED STYLE",
    "generate.developing": "DEVELOPING",
    "generate.step0": "Studying your face",
    "generate.step1": "Dressing you up",
    "generate.step2": "Painting the background",
    "generate.step3": "Adding finishing touches",
    "generate.remaining": "about {sec}s remaining",
    "generate.almostDone": "Almost there",
    "generate.queueWait": "The queue is busy — please wait a moment",
    "generate.tookTooLong": "Taking longer than usual",
    "generate.failed": "The transformation failed",
    "generate.cancel": "Cancel",
    "generate.retry": "Try again",
    "generate.proceed": "Continue anyway",
    "generate.back": "Back to camera",
    "review.title": "Here you are",
    "review.retake": "Retake",
    "review.next": "Get my photo",
    "review.makeVideo": "✨ Make a video too",
    "review.makeVideoPriced": "✨ Make a video too · +{price}",
    "review.slotError": "Transform failed",
    "videoIntro.back": "Back to result",
    "videoIntro.title": "Living Portrait",
    "videoIntro.body": "A 5-second vertical video.\nSave it to your phone and post right away.",
    "videoIntro.cta": "Make it",
    "videoIntro.skip": "Photo only",
    "videoMotions.back": "Back to result",
    "videoMotions.title": "Pick your motions",
    "videoMotions.subtitle": "Up to two · they play in the order you pick",
    "videoMotions.hint": "Choose at least one motion",
    "videoMotions.next": "Next",
    "videoCaption.back": "Back",
    "videoCaption.title": "Leave a line?",
    "videoCaption.subtitle": "It appears as a caption in your video",
    "videoCaption.placeholder": "Up to 12 characters",
    "videoCaption.preset1": "Jeju, today",
    "videoCaption.preset2": "A day the wind brought",
    "videoCaption.preset3": "May we last long",
    "videoCaption.preset4": "Only good things",
    "videoCaption.next": "Next",
    "videoCaption.skip": "Skip",
    "videoGenerate.back": "Back to result",
    "videoGenerate.title": "Starting your moving shot",
    "videoGenerate.caption": "Just a moment",
    "videoGenerate.error": "Video generation failed",
    "videoGenerate.retry": "Try again",
    "videoGenerate.skipToPhoto": "Photo only",
    "videoGenerate.refunded": "The video charge is refunded automatically to your payment method.",
    "payment.title": "Payment",
    "payment.cancel": "Cancel",
    "payment.kicker": "SCAN TO PAY",
    "payment.itemPhoto": "Photo print ×1",
    "payment.itemVideo": "Living Portrait · 5s",
    "payment.total": "Total",
    "payment.qrHeading": "Pay with your phone",
    "payment.qrHint": "Point your phone camera at the QR code",
    "payment.methods": "KakaoPay · NaverPay · TossPay · Card",
    "payment.noticeVideo": "Video creation starts once payment is confirmed.\nNothing is made before you pay.",
    "payment.noticePhoto": "Your photo is ready to collect once payment is confirmed.",
    "payment.remaining": "{time} left",
    "payment.wifiHint": "No mobile data? Use the store Wi-Fi.",
    "payment.connectionLost": "Checking the connection. We'll continue automatically once payment goes through.",
    "payment.failedHint": "The payment didn't go through. Please try again on your phone.",
    "payment.unavailable": "Payment isn't available right now.\nPlease call a staff member.",
    "payment.createError": "Couldn't set up the payment. Please try again.",
    "payment.expired": "The payment timed out. Please start again.",
    "payment.closed": "The payment was cancelled. Please start again.",
    "printShare.title": "Take your photo",
    "printShare.kicker": "SCAN TO SAVE",
    "printShare.qrHeading": "Save to your phone",
    "printShare.desc1": "Scan the QR to save",
    "printShare.desc2": "Link expires in {days} days",
    "printShare.privacy": "Originals deleted right after transform · Generated deleted in {days} days",
    "printShare.printCta": "Print",
    "printShare.retake": "Retake",
    "printShare.home": "Start over",
    "printShare.doneCta": "Done",
    "printShare.shareHint": "Tap Print, then choose 'Print' from the share sheet",
    "printShare.bodyWithVideo": "Scan the QR to receive both photo and video.",
    "printShare.bodyVideoPending": "Your photo is ready now. The video appears\non the same link in about 2 minutes.",
    "printShare.bodyVideoFailed": "We couldn't make the video.\nYour photo is still yours to keep.",
    "printShare.videoPendingLabel": "In the making",
    "printShare.photoLabel": "Photo",
    "printShare.videoLabel": "Video",
    "printShare.uploading": "Upload",
    "printShare.uploadError": "Upload failed. Please try again.",
    "printShare.retry": "Retry",
    "printShare.qrAlt": "QR code for your photo page",
    "printShare.agentOffline": "Checking the printer connection. Printing may be delayed.",
    "thanks.title": "Thank you",
    "thanks.body": "Your photo is saved · returning home in {sec}s",
    "thanks.tapHint": "Tap the screen to return now",
    "lock.title": "Currently unavailable",
    "lock.body": "현재 사용할 수 없습니다",
    "print.title": "Printing…",
    "print.sub": "Don't forget to take your photo.",
    "print.status": "PRINTING · 1 / 1 · ~18s",
    "print.preparing": "Getting ready to print…",
    "print.delayed": "Printing is taking longer than expected.\nPlease call a staff member.",
    "print.delayedHint": "You can still get your photo with the QR code.",
    "print.failed": "Printing failed.\nPlease call a staff member.",
    "print.paperOut": "The printer is out of paper.\nPlease call a staff member.",
};
//# sourceMappingURL=en.js.map